import React, { useEffect, useState } from "react";
import styles from "./CompetitionOffers.module.css";

const Countdown: React.FC<{ deadline: Date | string }> = ({ deadline }) => {
  const [now, setNow] = useState<Date | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setNow(new Date());
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Prevent hydration mismatch by not rendering time-dependent content on server
  if (!mounted || !now) {
    return <span>Loading...</span>;
  }

  const end = typeof deadline === "string" ? new Date(deadline) : deadline;
  if (!end || isNaN(end.getTime())) return <span>Ends: -</span>;
  const diff = end.getTime() - now.getTime();
  if (diff <= 0) return <span>Expired</span>;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const secs = Math.floor((diff / 1000) % 60);

  const isLessThanOneDay = days === 0;
  const isLessThanSevenDays = days < 7;
    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <span className={styles["endsLabel"]}>Ends:</span>
        {!isLessThanOneDay && <span className={styles.pill}>{days.toString().padStart(2, "0")}d</span>}
        <span className={styles.pill}>{hours.toString().padStart(2, "0")}h</span>
        <span className={styles.pill}>{minutes.toString().padStart(2, "0")}m</span>
        {isLessThanOneDay && <span className={styles.pill}>{secs.toString().padStart(2, "0")}s</span>}
      </span>
    );
};

export default Countdown; 



